var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContactsMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contacts",
    transform: "translate(-466 -562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474",
    transform: "translate(-0.593 0.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M17.62,22.259c.047-.069.456-.014.523-.106.028-.265,2.16.547,2.352,1.008-.432.418-.952.857-1.359,1.24a2.46,2.46,0,0,0-.8,1.867c0,1.65,0,.759,0,2.409a1.2,1.2,0,0,0,.008.183.358.358,0,0,0,.361.326.351.351,0,0,0,.337-.347c.006-.076,0-.153,0-.229,0-1.581.01-.622,0-2.2a2,2,0,0,1,.689-1.612c.325-.287.623-.6,1-.9a4.381,4.381,0,0,1,.046.543c-.031.9-.122,1.333-.16,2.233-.057,1.373-.064.675-.12,2.048,0,.008,0,.015,0,.023,0,.271.121.432.336.441s.362-.156.375-.437q.043-1,.084-1.991c.066-1.587.132-.634.2-2.221a2.612,2.612,0,0,0-1.113-2.384c-.169-.108-.381-.006-.568-.085a5,5,0,0,0-.618-.229C18.292,21.595,17.2,22.868,17.62,22.259Zm-.438-.6",
    transform: "translate(467.934 557.266)",
    fill: "#0000b5",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M8.567,0c.332.06.669.1.994.184a3.488,3.488,0,0,1,2.79,3.361c.023.53-.055,1.064-.073,1.6a.675.675,0,0,0,.085.354,1.4,1.4,0,0,1,.04,1.461.853.853,0,0,1-.691.466.3.3,0,0,0-.323.275,3.147,3.147,0,0,1-.752,1.434c-.273.3-.116.639-.151.96,0,.016.023.038.04.052.376.333.75.668,1.13,1a.964.964,0,0,0,.274.169c.453.176.91.343,1.366.513.051.019.1.036.155.056.294.113.4.283.318.5-.078.2-.279.252-.563.148-.435-.159-.873-.31-1.3-.488-.195-.081-.295-.065-.414.119-.352.543-.73,1.07-1.1,1.6-.5.732-.732.824-1.571.642,0,.367-.014.738,0,1.107.082,1.884.172,1.229.256,3.113.013.294-.13.472-.36.467a.361.361,0,0,1-.346-.391q-.072-1.522-.14-3.044c0-.044-.029-.383-.029-.383a.856.856,0,0,0-.121-.363h-.8c-.027.54-.056,1.078-.08,1.617-.069,1.549-.135.557-.2,2.106,0,.031,0,.061,0,.091a.371.371,0,0,1-.376.365.351.351,0,0,1-.329-.4c.02-.6.048-1.206.074-1.808.072-1.625.145-.71.217-2.335,0-.045,0-.09,0-.161a2.992,2.992,0,0,1-.339.095,1.067,1.067,0,0,1-1.114-.488q-.631-.914-1.26-1.829c-.047-.069-.1-.135-.165-.227A11.129,11.129,0,0,0,1.115,13.1c.432.418.83.81,1.237,1.193a2.46,2.46,0,0,1,.8,1.867c0,1.65,0,.759,0,2.409a1.2,1.2,0,0,1-.008.183.358.358,0,0,1-.361.326.351.351,0,0,1-.337-.347c-.006-.076,0-.153,0-.229,0-1.581-.01-.622,0-2.2a2,2,0,0,0-.689-1.612c-.325-.287-.623-.6-1-.9a4.381,4.381,0,0,0-.046.543c.031.9.073,1.8.111,2.7.057,1.373.113.207.169,1.58,0,.008,0,.015,0,.023,0,.271-.121.432-.336.441s-.362-.156-.375-.437q-.043-1-.084-1.991c-.066-1.587-.132-.634-.2-2.221a2.338,2.338,0,0,1,1.132-2.2,3.623,3.623,0,0,1,.549-.264,5,5,0,0,1,.618-.229,4.21,4.21,0,0,0,2.239-1.4c.024-.03.052-.069.085-.078.306-.079.258-.313.255-.529a.794.794,0,0,0-.16-.617A3.086,3.086,0,0,1,3.972,7.68a.276.276,0,0,0-.289-.255.982.982,0,0,1-.874-.866,1.225,1.225,0,0,1,.5-1.338.243.243,0,0,0,.05-.209,7.985,7.985,0,0,1-.2-2.182,1.786,1.786,0,0,1,1.56-1.78.62.62,0,0,0,.207-.1A4.973,4.973,0,0,1,7.414.039,1.068,1.068,0,0,0,7.573,0ZM4.579,5.3l.344-.4a.361.361,0,0,1,.516-.1.325.325,0,0,1,.051.5,3.932,3.932,0,0,1-.535.575c-.344.292-.515.279-.862-.008a.335.335,0,0,0-.575.183.782.782,0,0,0,.011.428.471.471,0,0,0,.3.267.836.836,0,0,1,.823.761,3.152,3.152,0,0,0,6.086-.075.722.722,0,0,1,.762-.668.364.364,0,0,0,.352-.312c.107-.5-.077-.708-.595-.665a.585.585,0,0,1-.648-.353,4.032,4.032,0,0,1-.2-.464c-.047-.134-.116-.162-.263-.137-.97.165-2.5-.526-1.519-.559.588-.02,1.173-.12,1.759-.192.288-.035.4.016.522.273a3.65,3.65,0,0,1,.207.486c.067.235.2.306.455.214a5.453,5.453,0,0,0,.068-1.6,2.928,2.928,0,0,0-.847-1.868A3.21,3.21,0,0,0,8.961.76a4.837,4.837,0,0,0-3.739.828.859.859,0,0,1-.344.132,1.082,1.082,0,0,0-1,1.074,8.762,8.762,0,0,0,.073,1.481c.057.394-.019.9.623,1.03m3.1,7.088c.681-.576,1.34-1.132,2-1.691a.217.217,0,0,0,.082-.13c.009-.21,0-.42,0-.667a4.038,4.038,0,0,1-4.174,0c0,.232-.007.422,0,.612a.27.27,0,0,0,.082.174c.661.566,1.326,1.127,2.005,1.7M4.931,10.978l-.624.573c.483.7.959,1.4,1.445,2.091a.327.327,0,0,0,.51.08c.3-.276.581-.574.879-.873l-2.21-1.871m3.28,1.891c.3.292.578.573.869.84a.335.335,0,0,0,.53-.066c.467-.661.922-1.329,1.378-2A.166.166,0,0,0,11,11.49c-.173-.183-.357-.355-.54-.533l-2.11,1.786c-.041.035-.079.073-.137.126m-.516.488a.679.679,0,0,0-.356.825h.692c.045-.487.043-.493-.337-.825",
    transform: "translate(474.593 567.37)",
    fill: "#0000b5",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_784",
    "data-name": "Rectangle 784",
    transform: "translate(468 562)",
    fill: "none",
    stroke: "#0000b5",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 30,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 28.5,
    rx: 1.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_785",
    "data-name": "Rectangle 785",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 570.407)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_790",
    "data-name": "Rectangle 790",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 566.407)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_788",
    "data-name": "Rectangle 788",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 578.407)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_786",
    "data-name": "Rectangle 786",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 574.407)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_787",
    "data-name": "Rectangle 787",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 582.407)",
    fill: "#0000b5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_789",
    "data-name": "Rectangle 789",
    width: 5,
    height: 1.5,
    rx: 0.75,
    transform: "translate(466 586.407)",
    fill: "#0000b5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactsMaster);
export default __webpack_public_path__ + "static/media/icon-contacts-master.18d25834382fc3e12fc7e03dbdc03e08.svg";
export { ForwardRef as ReactComponent };